import { Radio } from 'antd';
import styled from 'react-emotion/macro';
import {
  width, space, color, fontSize, fontWeight, letterSpacing, borderColor,
} from 'styled-system';

export const WeekDayWrapper = styled(Radio.Group)` &&& {
  ${space}
  height: 100%;
}`;

export const WeekDayButton = styled(Radio.Button)` &&& {
  border: none;
  border-radius: 0;
  border-left: none;
  text-align: center;
  box-shadow: none;
  background: none;
  line-height: 15px;
  user-select: none;
  ${space}

  &:hover,
  &.ant-radio-button-wrapper-checked {
    ${color}
  }

  &.ant-radio-button-wrapper-checked {
    height: 99%;
    border-bottom: 2px solid;
    ${borderColor}
  }

  &:focus,
  &:focus-within {
    outline: 1px dashed #999;
  }

  ::before,
  ::after {
    display: none;
  }
}`;

export const ButtonText = styled.div`
  ${fontSize}
  ${fontWeight}
  ${space}
  ${letterSpacing}
  ${width}
  ${color}
`;
